import { Component, OnInit, HostListener } from '@angular/core';
import { IMyOptions } from 'mydatepicker';
import { UsersService } from '../users/users.service';
import { T2LoadingService } from '../../trip2-theme/components/t2-loading/t2-loading.service';
declare const jQuery: any;

@Component({
  selector: 'app-escalations',
  templateUrl: './escalations.component.html',
  styleUrls: ['./escalations.component.scss']
})
export class EscalationsComponent implements OnInit {

  private isLoadingHP = false;
  private myDatePickerOptions: IMyOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateField: false
  };

  private date: any;
  private endDate = '';
  private startDate = '';

  private selectedProvider = null;

  private providers: any[];

  constructor(private _serviceUser: UsersService, protected _loading: T2LoadingService) { }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {
    this.getAllProviders();
  }

  /**
   * @name getAllProviders
   * @description
   */
  getAllProviders() {
    this._serviceUser
      .getProvidersForUser()
      .subscribe(
        data => {
          this.providers = data;
        }
      );
  }

  /**
   * @name onLoadingMaskEmit
   * @description
   * @param event
   */
  onLoadingMaskEmit(event) {
    if (event) {
      this._loading.show();
    } else {
      this._loading.hiden();
    }
    this.isLoadingHP = event;
  }

  /**
   * @name HostListener
   * @description
   * @param event
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const x = event.keyCode;
    if (x === 27) {
      jQuery('.pac-container').remove();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/escalations/escalations.component.ts